import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './OffMarketDisplay.css';

interface PriceData {
  max_price: number;
  min_price: number;
  date: string;
}

const OffMarketDisplay: React.FC = () => {
  const { propertyId, unitNumber } = useParams<{ propertyId: string; unitNumber: string }>();
  const [dateSigned, setDateSigned] = useState<string>('');
  const [priceSigned, setPriceSigned] = useState<number>(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchPriceData = async () => {
      try {
        const effectivePropertyId = propertyId || localStorage.getItem('selectedPropertyId');
        const effectiveUnitNumber = unitNumber || localStorage.getItem('selectedUnitNumber');

        if (!effectivePropertyId || !effectiveUnitNumber) {
          throw new Error('Missing property or unit information');
        }

        const response = await fetch(
          `https://${process.env.REACT_APP_BASE_URL}/getPrices/${effectivePropertyId}/${effectiveUnitNumber}/1`
        );
        const data: PriceData[] = await response.json();
        
        if (data && data.length > 0) {
          setDateSigned(data[0].date);
          setPriceSigned(data[0].min_price);
        }
      } catch (error) {
        console.error('Error fetching price data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPriceData();
  }, [propertyId, unitNumber]);

  if (isLoading) {
    return (
      <div className="off-market-container">
        <div className="off-market-banner">
          <h2>Unit is Currently Off Market</h2>
        </div>
        <div className="off-market-details">
          <div className="detail-item loading">
            <span className="detail-label">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="off-market-container">
      <div className="off-market-banner">
        <h2>Unit is Currently Off Market</h2>
      </div>
      <div className="off-market-details">
        <div className="detail-item">
          <span className="detail-label">Date Signed:</span>
          <span className="detail-value">
            {new Date(dateSigned).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
          </span>
        </div>
        <div className="detail-item">
          <span className="detail-label">Price Signed:</span>
          <span className="detail-value">${priceSigned.toLocaleString()}</span>
        </div>
      </div>
    </div>
  );
};

export default OffMarketDisplay; 